import React from "react";
import ReactMarkdown from "react-markdown";
import uiStyles from "../../reportViewers/ReportUIPrimitives.module.css";
import styles from "./NarrativeAssessmentCardBase.module.css";
import {
  parseNarrativeAssessmentLine,
  splitNarrativeSentences,
} from "./narrativeAssessmentLineUtils";

const NarrativeAssessmentCardBase = ({
  markdown = "",
  Icon,
  subtitle = "Assessment signal",
  badge = "ASSESSMENT",
  titleOverride = "",
}) => {
  const parsed = parseNarrativeAssessmentLine(markdown);
  if (!parsed) return null;
  const displayTitle = String(parsed.title || "")
    .replace(/\s+Assessment\s*$/i, "")
    .trim();

  const sentences = splitNarrativeSentences(parsed.body);
  const normalizedBody = sentences.length > 0
    ? sentences.map((line) => `- ${line}`).join("\n")
    : parsed.body;

  return (
    <div className={styles.card}>
      <div className={styles.hero}>
        <div className={styles.heroLeft}>
          {Icon ? (
            <div className={styles.heroIcon} aria-hidden="true">
              <Icon size={18} />
            </div>
          ) : null}
          <div>
            <h4 className={styles.heroTitle}>
              {titleOverride || displayTitle || parsed.title}
            </h4>
          </div>
        </div>
        <p className={styles.heroSubtitle}>
          {subtitle || badge || "Assessment signal"}
        </p>
      </div>

      <div className={styles.sectionCard}>
        <div className={styles.markdownBody}>
          <ReactMarkdown
            components={{
              h2: ({ children }) => <h4 className={styles.heading}>{children}</h4>,
              h3: ({ children }) => <h4 className={styles.heading}>{children}</h4>,
              p: ({ children }) => <p className={styles.paragraph}>{children}</p>,
              ul: ({ children }) => <ul className={styles.list}>{children}</ul>,
              ol: ({ children }) => <ol className={styles.list}>{children}</ol>,
              li: ({ children }) => (
                <li className={styles.listItem}>
                  <span className={uiStyles.summaryCheck} aria-hidden="true" />
                  <span className={styles.listItemText}>{children}</span>
                </li>
              ),
              strong: ({ children }) => (
                <strong style={{ fontWeight: 800 }}>{children}</strong>
              ),
            }}
          >
            {normalizedBody}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default NarrativeAssessmentCardBase;
